import { capitalize } from 'helpers/utils';
import { useEffect, useMemo, useState } from 'react';
import { Dropdown, Nav } from 'react-bootstrap';
import { Route, RouteItems, routes } from 'sitemap';
import TopNavMegaMenu from './TopNavMegaMenu';
import TopNavItem from './TopNavItem';
import { useBreakpoints } from 'providers/BreakpointsProvider';
import { useLocation } from 'react-router-dom';
import { checkScope } from '../../../helpers/auth';
import { useTranslation } from 'react-i18next';

const NavbarTopNav = () => {
  // eslint-disable-next-line
  const { t }: { t: any } = useTranslation();
  const updateRoutes = useMemo(() => {
    return routes
      .filter(routeParent =>
        routeParent.permission ? checkScope(routeParent.permission) : true
      )
      .map(route => {
        const tempRoute: RouteItems = {
          ...route,
          label: t(route.label),
          pages: route.pages
            .filter(data =>
              data.permission ? checkScope(data.permission) : true
            )
            .map(route2 => {
              const tempRoute2: Route = {
                ...route2,
                name: t(route2.name),
                pages: route2.pages?.filter(data =>
                  data.permission ? checkScope(data.permission) : true
                )
              };

              return tempRoute2;
            })
        };

        return tempRoute;
      });
  }, [routes, t]);
  return (
    <Nav className="navbar-nav-top pb-4 pb-lg-0">
      {updateRoutes.map(route => (
        <NavbarTopNavItem route={route} key={route.label} />
      ))}
    </Nav>
  );
};

const NavbarTopNavItem = ({ route }: { route: RouteItems }) => {
  const Icon = route.icon;
  const [show, setShow] = useState(false);
  const { pathname } = useLocation();

  const { breakpoints } = useBreakpoints();

  const handleMouseEnter = () => {
    if (breakpoints.up('lg')) {
      setShow(true);
    }
  };

  const handleMouseLeave = () => {
    if (breakpoints.up('lg')) {
      setShow(false);
    }
  };

  useEffect(() => {
    if (show) {
      setShow(false);
    }
  }, [pathname]);

  return (
    <Dropdown
      as="li"
      show={show}
      className="nav-item"
      key={route.label}
      autoClose="outside"
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      onToggle={() => setShow(!show)}
    >
      <Dropdown.Toggle
        as="a"
        variant=""
        className="nav-link lh-1 d-flex align-items-center cursor-pointer px-2"
        // onClick={handleClick}
      >
        <Icon className="me-2" size={16} />
        <span>
          {capitalize(
            route.horizontalNavLabel ? route.horizontalNavLabel : route.label
          )}
        </span>
      </Dropdown.Toggle>
      {route.megaMenu ? (
        <TopNavMegaMenu route={route} />
      ) : (
        <TopNavItem route={route} />
      )}
    </Dropdown>
  );
};

export default NavbarTopNav;
